import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';

import { CollaborationIcon } from './collaborationIcon.model';

@Injectable()
export class CollaborationIconService {
  constructor(private http: HttpClient) {}
}
